export const contentPdfConstants = {
    GET_CONTENT_PDF_PENDING  : 'GET_CONTENT_PDF_PENDING',
    GET_CONTENT_PDF_FULFILLED: 'GET_CONTENT_PDF_FULFILLED',
    GET_CONTENT_PDF_REJECTED : 'GET_CONTENT_PDF_REJECTED',
};
